import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoggerData } from "./Logger.model";

@Injectable()
export class LoggerService  {
    constructor(private http: HttpClient) {
    }

    save(logData: LoggerData) {
        return this.http.post<void>(`api/EventLog/v1/EventLogs`, JSON.stringify(logData));
    }
}
